module.exports = __webpack_public_path__ + "media/images/flags/mg-b9fc65f0b79353b28d95f36c4167c5fd.svg";